import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { SharedStore } from '@shared/store/shared.signal-store';
import { waitToResolveSignal } from '@shared/utils/waitToResolve';

export const accountsResolver: ResolveFn<boolean> = () => {
  const sharedStore = inject(SharedStore);

  sharedStore.loadAccounts();
  sharedStore.loadAssets();
  sharedStore.loadPairs();
  sharedStore.loadLiquidityProviders();
  sharedStore.loadRoutePresets();

  return waitToResolveSignal(
    sharedStore.accountsLoaded,
    sharedStore.assetsLoaded,
    sharedStore.pairsLoaded,
    sharedStore.liquidityProvidersLoaded,
  );
};
